import { AssetUIModel, CanPipe } from '@thehubz/client/core';
import { CustomClients } from '@thehubz/shared/branding';
import { arvalAssetMetadataConfig } from './arval/arval-metadata-config';
import { lufthansaMetadataConfig } from './lufthansa/lufthansa-metadata-config';
import { vorwerkAssetMetadataConfig } from './vorwerk/vorwerk-metadata-config';

export function customerAssetInfoConfig(assetInfo: AssetUIModel, canPipe: CanPipe, brandingKey?: CustomClients) {
  if (brandingKey === CustomClients.Arval) {
    return arvalAssetMetadataConfig(assetInfo, canPipe);
  } else if (brandingKey === CustomClients.Vorwerk) {
    return vorwerkAssetMetadataConfig(assetInfo, canPipe);
  } else if (brandingKey === CustomClients.LufthansaMediacenter || brandingKey === CustomClients.LufthansaMedialounge) {
    return lufthansaMetadataConfig(assetInfo, canPipe, brandingKey);
  }
  return undefined;
}
